import type { HTMLAttributes, ReactNode } from 'react';
import { DEFAULT_CLOSING, DEFAULT_TRIGGER, segmentTokens } from './tokens.js';
import './TokenInput.css';

export interface TokenTextProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  /** The text to show, tokens and all. */
  value: string | null | undefined;
  trigger?: string;
  closing?: string;
  /** Shown when the value is empty. */
  empty?: ReactNode;
}

/**
 * A string with its `{{…}}` tokens painted, for anywhere a value is read
 * rather than edited: a review step, a table cell, a summary line. The same
 * cut and the same chip classes as the inputs, so what was picked in a field
 * looks the same on the page that repeats it.
 */
export function TokenText({ value, trigger = DEFAULT_TRIGGER, closing = DEFAULT_CLOSING, empty, className, ...rest }: TokenTextProps): ReactNode {
  const text = value ?? '';
  if (!text) return empty ?? null;
  const segments = segmentTokens(text, trigger, closing);
  return (
    <span className={['rr-token-text', className].filter(Boolean).join(' ')} {...rest}>
      {segments.map((s, i) => s.kind === 'text'
        ? <span key={i}>{s.text}</span>
        : <span key={i} className={`rr-token ${s.slot ? 'rr-token--slot' : 'rr-token--attr'}`}>{s.text}</span>)}
    </span>
  );
}
